import React from "react";
import { useNavigate } from "react-router-dom";

export default function SuperBuildUpHero() {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12">
          <div className="sp-Video-container">
            <video
              width="100%"
              controls={false}
              loop
              autoPlay
              muted
              playsInline
              className="sp-bg-video"
            >
              <source
                src="/images/SuperBuildUpBackground.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            <div className="sp-overlay-text px-6 pe-0">
              <div className="row">
                <div className="col-md-7 mt-5 pt-md-5">
                  <h1>
                    SuperBuildup : <br />A Real Estate ERP solution
                  </h1>
                  <p className="mt-4 mt-md-3">
                    Superbuildup is a modern real estate ERP software developed
                    for builders to manage their residential and commercial
                    projects. It functions as a centralized platform that
                    integrates various core business functions like sales,
                    marketing and project management in a single, efficient
                    system.
                  </p>
                </div>
                <div className="col-md-5 d-none d-md-block text-end">
                  <img src="/images/SuperBuildUpHero.png" alt="" />
                </div>
                <div className="col-md-5 d-md-none d-block">
                  <img src="/images/SpHeroMobile.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
